import React from 'react'

import type { RecipeHeaderTagGroup, RecipeThemedColor } from '@library/api-menu-experience'
import { RecipeTagLabels } from '@library/menu-page'

type RecipeOfferHeaderProps = {
  header?: RecipeHeaderTagGroup
}

// webclient has no dark theme, so only the light colours are used. A tag without colours is
// left to RecipeTagLabels to skip, rather than throwing and taking the details page down
const lightColour = (colour?: RecipeThemedColor) => colour && { light: colour.light }

// Uses the same tag as the menu grid tiles, pinned to the top left of the closest positioned
// ancestor (the recipe image). The tags are rendered exactly as supplied by Menu Experience:
// the text is not rewritten and the saving is not calculated here
export const RecipeOfferHeader = ({ header }: RecipeOfferHeaderProps) => {
  const labels = (header?.tags ?? [])
    .filter((tag) => tag.text)
    .map((tag) => ({
      type: tag.type,
      text: tag.text,
      color: lightColour(tag.color),
      backgroundColor: lightColour(tag.backgroundColor),
    }))

  return <RecipeTagLabels tags={labels} dataTestId="recipe-offer-header" />
}
